import { eEnvironments } from './utils/enums';

class Global {
  constructor() {
    this._config = {};
    this.logger = null;
    this._loadedComponents = [];
  }

  get config() {
    return this._config;
  }

  set config(value) {
    this._config = value;
  }

  get loadedComponents() {
    return this._loadedComponents;
  }

  set loadedComponents(value) {
    this._loadedComponents = value;
  }

  get logger() {
    return this._logger.get();
  }

  set logger(value) {
    this._logger = value;
  }

  get isProduction() {
    const { stage, prod } = eEnvironments;
    const currentEnv = this._config.environment;

    return currentEnv === stage || currentEnv === prod;
  }
}

export default new Global();
